<template>
    <div>
        <h2 class="m-0 h1 text-uppercase">{{ $t('perfil.resumen_compra') }}</h2>
        <div class="subtitle h3 light mb-4">
            {{ $t('perfil.resumen_compra_info', { entradas: manager.termino_entradas }) }}
            <h5 class="bold mt-1">{{ $t('perfil.coste_cambio', { entrada: manager.termino_entrada, coste_cambio_nombre: $n(datosCompra?.coste_cambio_nombre, "currency") }) }}</h5>
        </div>
        <b-row>
            <b-col cols="12">
                <ul v-for="(entrada, index) in entradasLocal" :key="index" class="resumen">
                    <li class="altcolor-content">
                        <div class="text-bold oswald text-uppercase m-0">   
                            {{ ++index }}. {{ entrada.qr }}
                        </div>
                    </li>
                    <li v-if="entrada.asiento?.zona">
                        <div class="h5 text-bold oswald text-uppercase m-0 w-100">
                            {{ entrada.asiento.zona }}
                        </div>
                    </li>
                    <li class="flex-grow-1">
                        <div class="h5 text-bold oswald text-uppercase m-0">
                            <template v-if="entrada.asiento">
                                {{ $t('perfil.fila') }}: {{ entrada.asiento.fila }} - {{ $t('general.butaca') }}: {{ entrada.asiento.asiento }}
                            </template>
                            <template v-else>
                                {{ $t('perfil.sin_numerar') }}
                            </template>
                        </div>
                    </li>
                    <li class="text-bold pr-0">
                        <label class="h5 pr-0">{{ $t('general.precio') }}</label>
                        <div class="h5 m-lg-0">
                            {{ datosCompra?.coste_cambio_nombre | formatear_precio }}
                        </div>
                    </li>
                </ul>
            </b-col>
            <b-col cols="12" class="mb-3">
                <label>{{ $t('perfil.total_pagar') }}</label>
                <div class="price price-large gradient-color">
                    {{ datosCompra?.total_resumen | formatear_precio }}
                </div>
            </b-col>
            <b-col cols="12" class="mt-4">
                <FormTerminos 
                    :error="error"
                    @continuar="aceptarCondiciones"
                />
            </b-col>
            <b-col cols="12" class="mt-4 text-right">
                <button @click="$emit('volver')" :class="!esMovil ? 'button effect-button large-button mr-2' : 'button effect-button mr-2'" data-cy="volver-cambiar-datos-paso-dos" id="volver-cambiar-datos-paso-dos" :disabled="procesar_pago">
                    <span>{{ $t('formularios.atras') }}</span>
                </button>
                <button @click="terminar" :class="!esMovil ? 'button effect-button large-button' : 'button effect-button'" data-cy="cambiar-datos-paso-tres" id="cambiar-datos-paso-tres" :disabled="procesar_pago">
                    <span>{{ $t('formularios.continuar') }}</span>
                </button>
            </b-col>
            <template v-if="datosCompra?.formulario" >
                <div id="formulario-compra" v-html="datosCompra.formulario" v-show="false"></div>
            </template>
        </b-row>
    </div>
</template>

<script>
    import FormTerminos from '@/components/frontend/components/FormTerminos';

    export default {
        props: {
            entradas: {
                type: Array,
                required: true
            },
            esMovil: {
                type: Boolean,
                required: false,
                default: false
            },
            datosCompra: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                error: null,
                terminos: false,
                procesar_pago: false,
                entradasLocal: [ ...this.entradas ]
            }
        },
        methods: {
            aceptarCondiciones(continuar) {
                this.terminos = continuar == true;
            },
            terminar() {
                if (this.terminos) {
                    if (this.datosCompra?.formulario) {
                        setTimeout(() => {
                            const form = document.querySelector('#formulario-compra form');
                            if (form) form.submit();
                        }, 500);
                    } else {
                        this.procesar_pago = true;
                        this.$emit('terminado');
                    }
                } else {
                    this.error = true;
                }
            }
        },
        computed: {
            manager() {
                return this.$store.getters.getFooter;
            }
        },
        components: {
            FormTerminos
        }
    }
</script>